import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[mcraiModalHeader], [mcrai-modal-header], mcrai-modal-header'
})
export class McRAIModalHeader {
  @HostBinding('class.mcrai-modal__header') cssClass = true;

  constructor() { }

}
